module.exports = {
  language: {
    name: '中文'
  },
  header: {
    lang: 'English',
    home: '首页',
    product: '产品展示',
    video: '视频中心',
    news: '新闻动态',
    about: '关于启高乐',
    search: '请输入产品关键字',
    langageimg: "en.png",
  },
  footer: {
    lang: 'English',
    home: '首页',
    product: '产品展示',
    video: '视频中心',
    news: '新闻动态',
    about: '关于启高乐',
    concact: '地址：汕头市启高乐科技实业有限公司　联系方式：电话：0754-85892999　QQ：2625317429　手机：17722135999　联系人：郑生 ',
    power: 'Copyright 汕头市启高乐科技实业有限公司 2022-2030 All Right Reserved ',
    address: '版本所有 <a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备18053044号-2</a>',
  }
}



// WEBPACK FOOTER //
// ./src/components/language/zh.js